import moment from "moment";
import React from "react";
export default class Helpers {

  static noImageLink = "https://staging-aspeedec.aspeed.ariba.sg/assets/images/product/no-image.jpeg"

  //Check is value is not null && not undefined
  static isValid(value) {
    if (value !== undefined) return true;
    if (value !== null) return true;
    return false;
  }

  //Check if value contain number only
  static isContainNumberOnly(value) {
    return /^\d+$/.test(value);
  }

  //Check if value contain number only
  static validateDecimal(input) {
    const regex = /^[0-9]*\.?[0-9]*$/;
    return regex.test(input);
  }

  //Check if value is null or empty
  static isNullOrEmpty(value) {
    return value === undefined || !value || value === null || value === '' || value === 'undefined';
  }

  //Check if value is null or empty
  static isNullOrEmptyAllowZero(value) {
    return value === undefined || value === null || value === '' || value === 'undefined';
  }

  //Check if value is null or empty
  static isArrayNullOrEmpty(value) {
    return !value && value !== undefined && value !== null && value !== "" && value?.length < 0
  }

  static nricFormatter = (value) => {
    let string = value.slice(0, 6) + "-" + value.slice(6, 8) + "-" + value.slice(8)
    return string;
  }

  //Check if NRIC validation
  static nricValidation = (value) => {
    if (value == "" || value == null) {
      return true;
    } else if (!this.isContainNumberOnly(value)) {
      return true;
    } else if (value.length < 12 || value.length > 12) {
      return true;
    } else {
      return false;
    }
  };

  static nameValidation = (name) => {
    if (name === "" || name === null) {
      return true;
    } else if (/\d/.test(name)) {
      return true;
    } else if (name.charAt(0) === " " || name.charAt(name.length - 1) === " ") {
      return true;
    } else if (name.length < 3) {
      return true;
    } else if (name.includes("  ")) {
      return true;
    } else if (
      name.includes("!") ||
      name.includes("#") ||
      name.includes("$") ||
      name.includes("%") ||
      name.includes("^") ||
      name.includes("*") ||
      name.includes("_") ||
      name.includes("+") ||
      name.includes("=") ||
      name.includes("|") ||
      name.includes("<") ||
      name.includes(">") ||
      name.includes("?") ||
      name.includes(`"`) ||
      name.includes(",") ||
      name.includes(":") ||
      name.includes(";") ||
      name.includes("{") ||
      name.includes("}") ||
      name.includes("[") ||
      name.includes("]") ||
      name.includes("~") ||
      name.includes("`")
    ) {
      return true;
    } else if (/(.)\1\1\1/.test(name)) {
      return true;
    } else {
      return false;
    }
  };

  static phoneNumberValidation = (value) => {
    // value = value.replaceAll("-", "");
    if (value == "") {
      return true;
    }
    else if (!this.isContainNumberOnly(value)) {
      return true;
    }
    // Temporary disabled
    // else if (value.charAt(3) != "1") {
    //   return Labels.ERROR_MOBILE_NUMBER;
    // }
    // else if (value.charAt(0) == "0") {
    //   return true;
    // } 
    else if (value.substring(0, 2) == "11" && value.length < 9) {
      return true;
    } else if (
      (value.substring(0, 2) == "10" ||
        value.substring(0, 2) == "12" ||
        value.substring(0, 2) == "13" ||
        value.substring(0, 2) == "14" ||
        value.substring(0, 2) == "15" ||
        value.substring(0, 2) == "16" ||
        value.substring(0, 2) == "17" ||
        value.substring(0, 2) == "18" ||
        value.substring(0, 2) == "19") &&
      value.length < 9
    ) {
      return true;
    } else {
      return false;
    }
  };


  static emailValidation = (value) => {
    const reg =
      /^[a-zA-Z0-9&(),./_\-]+@[a-zA-Z0-9]+\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?$/;

    if (this.isNullOrEmpty(value)) {
      return true;
    } else if (value.length > 60) {
      return true;
    } else if (value.charAt(0) === " ") {
      return true;
    } else if (!reg.test(value)) {
      return true;
    } else if (value.charAt(value.length - 1) === " ") {
      return true;
    } else {
      return false;
    }
  };

  static phoneLengthValidation = (value) => {
    if (value.length >= 9) {
      return true
    }
    else
      return false
  };



  static getYearList = () => {
    let yearArr = [];
    let thisYear = (new Date()).getFullYear();
    for (let i = 0; i <= 60; i++) {
      const year = thisYear - i;
      yearArr.push(year);
    }
    return yearArr;
  };

  static lastDayOfMonth(Year, Month) {
    return new Date((new Date(Year, Month, 1)) - 1);
  }

  static getMonthList = (index) => {
    let month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    return month;
  };

  //Covert string to capitalize
  static capitalize(string) {
    if (string)
      return string[0].toUpperCase() + string.substr(1).toLowerCase()
    else
      return
  }

  static capitalizeWords(str) {
    if (str?.length > 0 || !this.isNullOrEmpty(str)) {
      return str
        .toLowerCase()
        .split(' ')
        .map(function (word) {
          return word?.length > 0 ? word[0].toUpperCase() + word.substr(1) : '';
        })
        .join(' ');
    } else {
      return ''
    }

  }


  static convertToMB(size) {
    return (size / (1024 * 1024)).toFixed(2);
  }

  //Format number
  static formatNumber(num) {
    let value = num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    if (value === "NaN") {
      return 0;
    }
    return value;
  }

  static getUniqueListBy(arr, key) {
    return [...new Map(arr.map(item => [item[key], item])).values()]
  }

  //Format number with commas
  static numberWithCommas(x) {
    if (x) {
      let number = Number(x).toFixed(2);
      return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
      return '';
    }

  }

  static downloadBinary(response, filename) {
    let a = document.createElement('a');
    a.href = window.URL.createObjectURL(new Blob([response]))
    a.download = filename
    document.body.appendChild(a)
    a.click();
    document.body.removeChild(a)
  }

  static truncateString(str, num) {
    // If the length of str is less than or equal to num
    // just return str--don't truncate it.
    if (str.length <= num) {
      return str;
    }
    // Return str truncated with '...' concatenated to the end of str.
    return str.slice(0, num) + "...";
  }


  static addFirstItemInArray(arr, object) {
    return [object].concat(arr)
  }

  static validatePassword(value, name) {
    let expregular = "^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[_!@#\$%\^&\*])(?=.{8,})";
    let error = null;
    if (!value) {
      error = `Please enter ${name} password.`;
    } else if (!value.match(expregular)) {
      error = "Password must contain between 8-16 characters, with upper case, lower case, special character and numeric characters.";
    }
    return error
  }

  static validateUserName(value, name) {
    let error = null;
    if (!value) {
      error = `Please enter user name`;
    }
    return error
  }

  static validateField(value, name) {
    let error = null;
    if (!value) {
      error = `Please enter ${name}`;
    }
    return error
  }

  //compareDateToCurrentDate (yyyy-mm-dd)
  static compareDateToCurrentDate(date) {
    var today = new Date().setHours(0, 0, 0, 0);
    var eventOn = new Date(date).setHours(0, 0, 0, 0);
    let type = "";
    if (today < eventOn) {
      type = "incoming";
    } else if (today > eventOn) {
      type = "pass";
    } else {
      type = "today";
    }
    return type;
  }

  static replaceBulk(str, findArray, replaceArray) {
    var i, regex = [], map = {};
    for (i = 0; i < findArray.length; i++) {
      regex.push(findArray[i].replace(/([-[\]{}()*+?.\\^$|#,])/g, '\\$1'));
      map[findArray[i]] = replaceArray[i];
    }
    regex = regex.join('|');
    str = str.replace(new RegExp(regex, 'g'), function (matched) {
      return map[matched];
    });
    return str;
  }
  //field need to search , and value 
  static findItemInArray(list, field, value) {
    let item = [];
    item = list.filter(
      function (ev) {
        return ev[field] == value;
      }
    );
    return item
  }

  static displayStatusString(value) {
    let status = '';
    status = value === 'pending' ? "Pending Order" :
      value === 'confirmed' || value === 'ordered' ? "Confirmed" :
        value === 'payment_failed' ? "Payment Failed" :
          value === 'closed' ? "Closed" :
            value === 'cancelled' ? "Cancelled" :
              value === 'shipped' ? "Shipped" :
                value === 'ready_for_pickup' ? "Ready For Pickup" :
                  value === 'delivered' ? "Delivered" :
                    value === 'refunded' ? "Refunded" :
                      value === 'pending_approval' ? "Pending Approval" :
                        value === 'published' ? "Published" :
                          value === 'rejected' ? "Rejected" :
                            "Partially Refunded"
    return status;
  }

  static displayReviewStatusString(value) {
    let status = '';
    status = value === 'pending_approval' ? "Pending Approval" :
      value === 'approved' ? "Published" : "Rejected"
    return status;
  }

  static displayProductStatusString(value) {
    let status = '';
    status = value === 2 ? "Pending Approval" :
      value === 1 ? "Published" :
        value === 'approved' ? "Approved" :
          value === 'rejected' ? "Rejected" :
            value === 'pending_approval' ? "Pending Approval" :
              "Unpublished"
    return status;
  }

  static statusList = [
    { value: '0', label: "All statuses" },
    { value: 'pending', label: "Pending Order" },
    { value: 'ordered', label: "Confirmed" },
    { value: 'shipped', label: "Shipped" },
    { value: 'ready_for_pickup', label: "Ready For Pickup" },
    { value: 'delivered', label: "Delivered" },
    { value: 'payment_failed', label: "Payment Failed" },
    { value: 'closed', label: "Closed" },
    { value: 'cancelled', label: "Cancelled" },
    { value: 'refunded', label: "Refunded" },
    { value: 'partially_refunded', label: "Partially Refunded" },
  ];

  static productStatusList = [
    { value: 'all', label: "All statuses" },
    { value: '1', label: "Published" },
    { value: '0', label: "Unpublished" },
    // { value: '2', label: "Pending Approval" },
  ];

  static base64ToBlob = (base64) => {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: 'application/pdf' });
  };

  static handleOpenPdfInNewTab = (base64Pdf) => {
    const blob = this.base64ToBlob(base64Pdf);
    const url = URL.createObjectURL(blob);
    window.open(url, '_blank');
  };

  static isFileSizeValid = (file, size = 1) => {
    const maxSizeInBytes = size * 1024 * 1024; // 1MB in bytes
    return file.size <= maxSizeInBytes;
  };

  static handleDownload = (base64Pdf, filename) => {
    let date = moment(new Date()).format("YYYYMMDDhhmmss");
    const linkSource = `data:application/pdf;base64,${base64Pdf}`;
    const downloadLink = document.createElement("a");
    const fileName = filename;
    downloadLink.href = linkSource;
    downloadLink.download = `${fileName}_${date}`;
    downloadLink.click();
  }

  static handleDownloadExcelFile(base64Data, fileName) {
    let date = moment(new Date()).format("YYYYMMDDhhmmss");
    const downloadLink = document.createElement('a');
    downloadLink.href = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + base64Data;
    downloadLink.download = `${fileName}_${date}`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  static handleDownloadExcelFileExact(base64Data, fileName) {
    const downloadLink = document.createElement('a');
    downloadLink.href = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' + base64Data;
    downloadLink.download = fileName;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }

  static handleDownloadDocument(link, fileName, completeFilename = false) {

    let date = moment(new Date()).format("YYYYMMDDhhmmss");
    fetch(link)
      .then(res => res.blob())
      .then(blob => {
        const blobUrl = window.URL.createObjectURL(blob);
        const downloadLink = document.createElement('a');
        downloadLink.href = blobUrl;
        downloadLink.download = `${fileName}${!completeFilename ? `_${date}.${this.getFileExtension(link)}` : ''}`;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        window.URL.revokeObjectURL(blobUrl);
      });
  }

  static handleRetrieveToken() {
    let isRemember = localStorage.getItem("remember");
    let token = JSON.parse(localStorage.getItem("token"))
    if ((isRemember === 'false' || isRemember === false) && !token) {
      token = JSON.parse(localStorage.getItem("token"))
    }
    return token;
  }

  static convertToCustomTitleCase(input) {
    if (input === "return_refund") {
      return input
        .split('_')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' / ');
    }

    return input
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  static getValueFromData(data, id, returnValue) {
    if (!Array.isArray(data) || data.length === 0) {
      return <span>-</span>;
    }
    const filteredValue = data.find((item) => item.id === id);
    const value = filteredValue?.[returnValue];
    return value ? this.capitalize(value) : <span>-</span>;
  }

  static getValueFromDataForTab(data, id, setValue) {
    if (!Array.isArray(data) || data.length === 0) {
      return <span>-</span>;
    }
    setValue({
      id: data?.[id]?.id,
      name: data?.[id]?.name,
      icon: data?.[id]?.icon
    })
  }


  static getValueFromDataForProductSpecTab(data, id, setValue, setAllowMultipleSelect) {
    if (!Array.isArray(data) || data.length === 0) {
      return <span>-</span>;
    }
    setValue({
      id: data?.[id]?.descriptions?.[0]?.configuration_id,
      name: data?.[id]?.descriptions?.[0]?.name,
      icon: data?.[id]?.descriptions?.[0]?.icon,
    })
    let temp = data?.filter((item, idx) =>
      item?.descriptions?.[0]?.allow_multiple_select === 1
    ).map((y, i) => y?.id)
    setAllowMultipleSelect(temp)
  }

  static getTabIdFromIndex(data, id) {
    if (!Array.isArray(data) || data.length === 0) {
      return <span>-</span>;
    }
    const filteredValue = data[id]?.id;
    return filteredValue;
  }

  static getArrayInfo(data, id, info) {
    const filteredValue = data?.find((item) => item.id === id);
    const value = filteredValue?.[info];
    return value || <span>-</span>;
  }

  static openTabs() {
    const openTabs = parseInt(localStorage.getItem("openTabs") || "0", 10) + 1;
    localStorage.setItem("openTabs", openTabs);
  }
  static getPreviewBase64(file, set) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      set(reader.result)
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }

  static getBase64(file, set) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      // Remove the `data:image/jpeg;base64,` or similar prefix
      const base64String = reader.result.split(',')[1]; // Split by comma and get the second part
      set(base64String);
    };
    reader.onerror = function (error) {
      console.log('Error: ', error);
    };
  }
  static imageToBase64Sync(url, callback) {
    if (!Helpers?.isValidURL(url)) {
      callback(url);
      return;
    }

    fetch(url)
      .then(response => response.blob())
      .then(blob => {
        const reader = new FileReader();
        reader.onloadend = () => callback(reader.result); // Pass Base64 when ready
        reader.readAsDataURL(blob);
      })
      .catch(error => {
        console.error("Error converting image:", error);
        callback(url); // Return original URL if fetch fails
      });
  }

  static isValidURL(url) {
    try {
      new URL(url);
      return true;
    } catch (_) {
      return false;
    }
  }

  static getBase64Arry(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = function () {
        const base64String = reader.result.split(',')[1]; // Get base64 string
        resolve(reader.result);
      };

      reader.onerror = function (error) {
        reject(error);
      };
    });
  }

  static getCustomErrorMessageByPrefix(errors, prefix, errorMsg) {
    const hasErrors = Object.entries(errors).some(([key, value]) => key.startsWith(prefix));

    if (hasErrors) {
      return errorMsg || `Some fields are invalid or incomplete.`;
    }

    return null;
  }

  static getCustomSpecificErrorMessageSpec(errors, prefix, errorMsg) {
    const hasErrors = Object.entries(errors).some(([key, value]) => key.startsWith(prefix));
    if (hasErrors) {
      return errors?.[prefix];
    }

    return null;
  }

  static getCustomErrorMessageByPrefixCard(errors, prefix, errorMsg) {
    const hasErrors = Object.entries(errors).some(([key, value]) => key.startsWith(prefix));

    if (hasErrors) {
      return errorMsg || `Some fields are invalid or incomplete.`;
    }

    return null;
  }


  static createDropdown = (data) => {
    const transformedData = data && Object.keys(data).map((key) => ({
      value: key,  // Convert the string key to a number
      label: data[key]   //
    }));

    return transformedData
  }

  static HTMLRenderer = ({ htmlContent }) => {
    // Sanitize the HTML content before rendering  
    return (
      <div dangerouslySetInnerHTML={{ __html: htmlContent }} />
    );
  };

  static customerGroup = [
    { value: "1", label: "Standard" },
    { value: "2", label: "VIP" },
  ]

  static routeToLogin = () => {
    localStorage.removeItem('token');
    sessionStorage.removeItem('token')
    window.location.href = "/login";
  }

  static searchInterval = 800;

  static status = [
    { value: "all", label: "All statuses" },
    { value: "1", label: "Active" },
    { value: "0", label: "Inactive" },
  ]

  static regionList = [
    { label: 'Central', value: 'central' },
    { label: 'North', value: 'north' },
    { label: 'Northeast', value: 'northeast' },
    { label: 'East', value: 'east' },
    { label: 'West', value: 'west' },
  ]

  static blacklist = [
    { value: "1", label: "Yes" },
    { value: "0", label: "No" },
  ]

  static gender = [
    { value: "Female", label: "Female" },
    { value: "Male", label: "Male" },
    // { value: "Other", label: "Other" },
  ]

  static nationalities = [
    { value: "Malaysian", label: "Malaysian" },
    { value: "Non-Malaysian", label: "Non-Malaysian" },
  ]

  static state = [
    { value: "1", label: "Johor" },
    { value: "2", label: "Kedah" },
    { value: "3", label: "Kelantan" },
    { value: "4", label: "Melaka" },
    { value: "5", label: "Negeri Sembilan" },
    { value: "6", label: "Pahang" },
    { value: "7", label: "Pulau Pinang" },
    { value: "8", label: "Perak" },
    { value: "9", label: "Perlis" },
    { value: "10", label: "Selangor" },
    { value: "11", label: "Terengganu" },
    { value: "12", label: "Sabah" },
    { value: "13", label: "Sarawak" },
    { value: "14", label: "WP Kuala Lumpur" },
    { value: "15", label: "WP Labuan" },
    { value: "16", label: "WP Putrajaya" },
  ]

  static races = [
    { label: "Chinese", value: "1" },
    { label: "Malay", value: "2" },
    { label: "Indian", value: "4" },
    { label: "Dayak", value: "5" },
    { label: "Iban", value: "3" },
  ]

  static monthList_24 = [
    // { label: 'As of today', value: 0 },
    { label: '1 month', value: 1 },
    { label: '2 months', value: 2 },
    { label: '3 months', value: 3 },
    { label: '4 months', value: 4 },
    { label: '5 months', value: 5 },
    { label: '6 months', value: 6 },
    { label: '7 months', value: 7 },
    { label: '8 months', value: 8 },
    { label: '9 months', value: 9 },
    { label: '10 months', value: 10 },
    { label: '11 months', value: 11 },
    { label: '12 months', value: 12 },
    { label: '13 months', value: 13 },
    { label: '14 months', value: 14 },
    { label: '15 months', value: 15 },
    { label: '16 months', value: 16 },
    { label: '17 months', value: 17 },
    { label: '18 months', value: 18 },
    { label: '19 months', value: 19 },
    { label: '20 months', value: 20 },
    { label: '21 months', value: 21 },
    { label: '22 months', value: 22 },
    { label: '23 months', value: 23 },
    { label: '24 months', value: 24 }
  ];

  static discount_type = [
    { name: "No discount", id: 'no_discount' },
    { name: "Percentage Discount (%)", id: 'percentage' },
    { name: "Fixed Amount DIscount (S$)", id: 'fixed_amount' },
  ]

  static is_percentage = [
    { name: "Percentage Discount (%)", id: 1 },
    { name: "Fixed Amount Discount (S$)", id: 0 },
  ]

  // static product = [
  //   { name: "ThinkVision T27i-30 27 inch Monitor", id: 1, category_id: 5, price: 609.00, category_name: "Accessories" },
  //   { name: "Lenovo 65W USB-C AC Travel Adapter", id: 2, category_id: 5, price: 39.00, category_name: "Accessories" },
  //   { name: "Lenovo Wireless VoIP Headset", id: 3, category_id: 5, price: 100.00, category_name: "Accessories" },
  //   { name: `ThinkVision T34w-30 34" Monitor`, id: 4, category_id: 5, price: 400.00, category_name: "Accessories" },
  // ]

  static categories = [
    { name: "Laptop", id: 1, },
    { name: "Workstation", id: 2 },
    { name: "Desktop", id: 3 },
    { name: `Monitor`, id: 4 },
    { name: `Accessories`, id: 5 },
  ]

  static displayName = [
    { id: 1, name: "Depot Support" },
    { id: 2, name: "Onsite Support" },
    { id: 3, name: "Premier Onsite Support" },
    { id: 4, name: "Premier Support Plus" },
  ]

  static icon = [
    { icon: "ri-tv-2-line", label: "ri-tv-2-line" },
    { icon: "ri-mac-line", label: "ri-mac-line" },
    { icon: "ri-macbook-line", label: "ri-macbook-line" },
    { icon: "fa-solid fa-computer", label: "fa-solid fa-computer" },
    { icon: "ri-smartphone-line", label: "ri-smartphone-line" },
    { icon: "ri-tablet-line", label: "ri-tablet-line" },
    { icon: "ri-device-line", label: "ri-device-line" },
    { icon: "ri-phone-line", label: "ri-phone-line" },
    { icon: "ri-database-2-line", label: "ri-database-2-line" },
    { icon: "ri-hard-drive-2-line", label: "ri-hard-drive-2-line" },
    { icon: "ri-server-line", label: "ri-server-line" },
    { icon: "ri-save-3-line", label: "ri-save-3-line" },
    { icon: "ri-sd-card-line", label: "ri-sd-card-line" },
    { icon: "ri-sim-card-2-line", label: "ri-sim-card-2-line" },
    { icon: "ri-u-disk-line", label: "ri-u-disk-line" },
    { icon: "ri-battery-2-line", label: "ri-battery-2-line" },
    { icon: "ri-battery-line", label: "ri-battery-line" },
    { icon: "ri-cast-line", label: "ri-cast-line" },
    { icon: "ri-airplay-line", label: "ri-airplay-line" },
    { icon: "ri-cpu-line", label: "ri-cpu-line" },
    { icon: "ri-keyboard-box-line", label: "ri-keyboard-box-line" },
    { icon: "ri-mouse-line", label: "ri-mouse-line" },
    { icon: "ri-sensor-line", label: "ri-sensor-line" },
    { icon: "ri-router-line", label: "ri-router-line" },
    { icon: "ri-radar-line", label: "ri-radar-line" },
    { icon: "ri-gamepad-line", label: "ri-gamepad-line" },
    { icon: "ri-remote-control-2-line", label: "ri-remote-control-2-line" },
    { icon: "ri-fingerprint-line", label: "ri-fingerprint-line" },
    { icon: "ri-barcode-line", label: "ri-barcode-line" },
    { icon: "ri-qr-code-line", label: "ri-qr-code-line" },
    { icon: "ri-qr-scan-2-line", label: "ri-qr-scan-2-line" },
    { icon: "ri-rss-line", label: "ri-rss-line" },
    { icon: "ri-gps-line", label: "ri-gps-line" },
    { icon: "ri-base-station-line", label: "ri-base-station-line" },
    { icon: "ri-bluetooth-line", label: "ri-bluetooth-line" },
    { icon: "ri-wifi-line", label: "ri-wifi-line" },
    { icon: "ri-usb-line", label: "ri-usb-line" },
    { icon: "ri-ram-2-line", label: "ri-ram-2-line" },
    { icon: "ri-plug-line", label: "ri-plug-line" },
    { icon: "ri-windy-line", label: "ri-windy-line" },
    { icon: "ri-radio-button-line", label: "ri-radio-button-line" },
    { icon: "ri-fridge-line", label: "ri-fridge-line" },
    { icon: "ri-shut-down-line", label: "ri-shut-down-line" },
    { icon: "ri-microsoft-fill", label: "ri-microsoft-fill" },
    { icon: "ri-switch-line", label: "ri-switch-line" },
    { icon: "ri-camera-line", label: "ri-camera-line" },
    { icon: "ri-camera-lens-line", label: "ri-camera-lens-line" },
    { icon: "ri-music-2-line", label: "ri-music-2-line" },
    { icon: "ri-headphone-line", label: "ri-headphone-line" },
    { icon: "ri-mic-line", label: "ri-mic-line" },
    { icon: "ri-speaker-3-line", label: "ri-speaker-3-line" },
    { icon: "ri-apps-line", label: "ri-apps-line" },
    { icon: "ri-lock-password-line", label: "ri-lock-password-line" },
    { icon: "ri-leaf-line", label: "ri-leaf-line" },


    { icon: "ri-shield-check-line", label: "ri-shield-check-line" },
    { icon: "ri-puzzle-line", label: "ri-puzzle-line" },
    { icon: "ri-sticky-note-add-line", label: "ri-sticky-note-add-line" },
    { icon: "ri-customer-service-2-line", label: "ri-customer-service-2-line" },
    { icon: "ri-presentation-line", label: "ri-presentation-line" },
    { icon: "ri-shield-user-line", label: "ri-shield-user-line" },
    { icon: "ri-building-line", label: "ri-building-line" },
    { icon: "ri-global-line", label: "ri-global-line" },
    { icon: "ri-tools-line", label: "ri-tools-line" },
    { icon: "ri-settings-5-line", label: "ri-settings-5-line" },


  ]

}
